import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[600px] md:h-[700px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Korean%20cinema%20film%20reel%20with%20dramatic%20spotlight%20on%20dark%20stage%2C%20cinematic%20atmosphere%20with%20warm%20golden%20and%20red%20accents%2C%20film%20strip%20flowing%20through%20the%20scene%2C%20elegant%20theater%20curtain%20texture%2C%20sophisticated%20movie%20aesthetic%2C%20no%20text%20no%20letters%20no%20words&width=1800&height=900&seq=hero-korean-cinema&orientation=landscape"
        alt="韩国电影 - 韩影深解"
        className="w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/70"></div>
      <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-4">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white mb-4 leading-tight">
          探索韩国电影的魅力世界
        </h1>
        <p className="text-sm md:text-lg text-white/80 max-w-2xl mb-8 leading-relaxed">
          从经典佳作到最新力作，深度解析韩国电影的叙事风格、社会议题与文化内涵，为你提供最全面的韩国电影观影指南
        </p>
        <div className="flex flex-col sm:flex-row items-center gap-3">
          <Link
            to="/category/crime-thriller"
            className="px-8 py-3 bg-primary-500 text-white font-medium rounded-full hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap text-sm"
          >
            浏览电影分类
          </Link>
          <Link
            to="/article/bong-joon-ho-narrative-evolution"
            className="px-8 py-3 bg-white/10 backdrop-blur-sm text-white border border-white/30 font-medium rounded-full hover:bg-white/20 transition-colors cursor-pointer whitespace-nowrap text-sm"
          >
            阅读深度解析
          </Link>
        </div>
        <div className="flex items-center gap-6 mt-10">
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-heading font-bold text-accent-500">12+</p>
            <p className="text-xs text-white/60 mt-1">精选电影</p>
          </div>
          <div className="w-px h-10 bg-white/20"></div>
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-heading font-bold text-accent-500">6</p>
            <p className="text-xs text-white/60 mt-1">电影分类</p>
          </div>
          <div className="w-px h-10 bg-white/20"></div>
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-heading font-bold text-accent-500">20+</p>
            <p className="text-xs text-white/60 mt-1">深度影评</p>
          </div>
        </div>
      </div>
    </section>
  );
}